import { render, staticRenderFns } from "./service-editor.vue?vue&type=template&id=5991e858&scoped=true&"
import script from "./service-editor.vue?vue&type=script&lang=js&"
export * from "./service-editor.vue?vue&type=script&lang=js&"
import style0 from "./service-editor.vue?vue&type=style&index=0&id=5991e858&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5991e858",
  null
  
)

export default component.exports